// removed by extract-text-webpack-plugin
module.exports = {"ScreenXSMax":"(max-width: 767px)","HeightSMMax":"(max-height: 639px)","ScreenSMMin":"(min-width: 768px)","SpacingXS":"7px","SpacingSM":"10px","imgSize":"250px","image":"G8725ce"};